export default function initFAQs() {
    // faq
    jQuery(document).ready(function($){

        jQuery('.faq').each(function(){
            const $accordion = jQuery(this);
            // $accordion.find('.faq-item').eq(0).addClass('active').find('.answer').show();
        
            $accordion.find('.question').on('click', function() {
            const $item = jQuery(this).closest('.faq-item');
            if (!$item.hasClass('active')) {
                $accordion.find('.faq-item').removeClass('active').find('.answer').slideUp();
                $item.addClass('active').find('.answer').slideDown();
            } else {
                $item.removeClass('active').find('.answer').slideUp();
            }
            });
        });   

        // double faq
        jQuery('.faq-questions').click(function(){
            var $faqItem = $(this).parent('.faq-items');
            var $allFaqItems = $('.faq-section .faq-items');

            if ($faqItem.hasClass('active')) {
                $faqItem.removeClass('active').children('.faq-answers').slideUp();
            } else {
                $allFaqItems.removeClass('active').children('.faq-answers').slideUp(); 
                $faqItem.addClass('active').children('.faq-answers').slideDown();      
            }
        });
         
        
    });

}